// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GfLg","colBig":"styles_colBig__3hbMF","colSmall":"styles_colSmall__3AA-r","shopifyNameWrapper":"styles_shopifyNameWrapper__1Hvxe"};